"use client";

import { userStore } from "@/store/user";
import { observer } from "mobx-react-lite";
import type { ReactNode } from "react";
import { RecentProjectsSection } from "./RecentProjectsSection";

interface ThreadListProps {
  communitySection?: ReactNode;
}

export const ThreadList = observer(({ communitySection }: ThreadListProps) => {
  const user = userStore.user;

  return (
    <div className="pb-6 mx-auto flex flex-col gap-12 px-5 sm:px-8 md:px-10 lg:px-11">
      {user && <RecentProjectsSection />}
      {communitySection}
    </div>
  );
});
